import React from 'react';
import './style.scss';
import SVGLandingMintArrow from '../../../../../assets/images/landing/mint_page/arrow';
import clsx from 'clsx';
import { useAssets } from '../../../../../contexts/assets';

interface Props {
  className?: string;
  direction?: 'right' | 'left';
  onClick?: () => any;
}

const ArrowButton = ({ className, direction = 'right', onClick }: Props) => {
  const { sound } = useAssets();

  const handleClick = () => {
    if (onClick) {
      onClick();
      sound.click();
    }
  };

  return (
    <button className={clsx('arrow-button', className)} onClick={handleClick}>
      <SVGLandingMintArrow className={`arrow-${direction}`} />
    </button>
  );
};

export default ArrowButton;
